import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { OWNER } from "constants/index"
import { useAppSelector } from "appRedux/hooks"
import { updateItemsTab } from "appRedux/slices/profileTabsSlice"
import { useLazyGetWishItemsQuery, wishItemApi } from "appRedux/slices/wishItemApiSlice"
import { useLazyGetUserWishItemsQuery, userProfileApi } from "appRedux/slices/userApiSlice"

export default function useWishItems() {
  const role = useAppSelector((state) => state.global.role)
  const currentPageInfo = useAppSelector((state) => state.global.currentPageInfo)
  const viewedUser = useAppSelector((state) => state.viewedUser)

  const cachedWishItems = useAppSelector((state) => {
    if (role === OWNER) {
      return wishItemApi.endpoints.getWishItems.select(undefined)(state)
    } else if (currentPageInfo?.dynamicPathParts?.handle) {
      return userProfileApi.endpoints.getUserWishItems.select(currentPageInfo?.dynamicPathParts?.handle)(state)
    }
    return null
  })

  const [triggerGetWishItems, loggedInUserWishItemsResult] = useLazyGetWishItemsQuery()
  const [triggerGetUserWishItems, viewedUserWishItemsResult] = useLazyGetUserWishItemsQuery()

  const dispatch = useDispatch()

  useEffect(() => {
    if (!currentPageInfo?.dynamicPathParts?.handle) return
    if (cachedWishItems?.data) {
      dispatch(updateItemsTab(cachedWishItems.data.items || []))
      return
    }
    fetchWishItems()
  }, [role, currentPageInfo?.dynamicPathParts])

  useEffect(() => {
    if (loggedInUserWishItemsResult?.data && role === OWNER) {
      dispatch(updateItemsTab(loggedInUserWishItemsResult?.data?.items || []))
    } else if (viewedUserWishItemsResult?.data) {
      dispatch(updateItemsTab(viewedUserWishItemsResult?.data?.items || []))
    }
  }, [loggedInUserWishItemsResult, viewedUserWishItemsResult])

  function fetchWishItems() {
    if (role === OWNER) {
      triggerGetWishItems()
    } else if (currentPageInfo?.dynamicPathParts?.handle) {
      triggerGetUserWishItems(currentPageInfo?.dynamicPathParts?.handle)
    }
  }

  return {
    items: viewedUser?.wishItems || cachedWishItems?.data?.items || [],
    isFetching: role === OWNER ? loggedInUserWishItemsResult.isFetching : viewedUserWishItemsResult.isFetching,
    isError: role === OWNER ? loggedInUserWishItemsResult.isError : viewedUserWishItemsResult.isError
  }
}
